import { ChannelPressureEntity } from '@models/channel-pressure-entity';
import { GeoLocation } from '@models/geo-location';

export class HowlerData {
  username: string; // Here for model uniformity. necessary for referenceSweep.
  timestamp: number; // The time the scan started. Unused as the timestamps on geoLocations are used instead.
  testDuration: number;
  geoLocations: HowlerGeoLocation[];
  channelPressure: ChannelPressureEntity[];
  version: string;  // To check the version and based on version need to plot the graph.

  constructor(
    httpResponse: HowlerData
  ) {
    this.username = httpResponse.username; // Here for model uniformity. necessary for referenceSweep.;
    this.timestamp = httpResponse.timestamp;
    this.testDuration = httpResponse.testDuration;
    this.geoLocations = httpResponse.geoLocations;
    this.channelPressure = httpResponse.channelPressure;
    this.version = httpResponse.version;
  }
}

export class HowlerGeoLocation extends GeoLocation {
  maxPower: number;
}
